<template>
  <div style="text-align: left">
    <div class="topDiv">
      <a-button
        size="middle"
        type="primary"
        @click="ShowModalEdit({})"
        v-if="group != 'ROLE_aftersale2'"
        >{{ i18n.$t("VersionControlAdd") }}</a-button
      >
    </div>
    <a-row>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlProjectName") }}</h4>
        <a-select
          show-search
          allowClear
          v-model:value="searchProjectValue"
          style="width: 90%"
          ref="select"
        >
          <a-select-option v-for="item in searchProjectOptions" :value="item">{{
            item
          }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlBomName") }}</h4>
        <a-select
          show-search
          allowClear
          v-model:value="searchMainBoardValue"
          style="width: 90%"
          ref="select"
        >
          <a-select-option
            v-for="item in searchMainBoardOptions"
            :value="item"
            >{{ item }}</a-select-option
          >
        </a-select>
      </a-col>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlLatestVersion") }}</h4>
        <a-input
          allowClear
          v-model:value="searchLatestVersionValue"
          style="width: 90%"
        />
      </a-col>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlLowerestVersion") }}</h4>
        <a-input
          allowClear
          v-model:value="searchMinVersionValue"
          style="width: 90%"
        />
      </a-col>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlBuildFix") }}</h4>
        <a-input
          allowClear
          v-model:value="searchBuildPrefixValue"
          style="width: 90%"
        />
      </a-col>
      <a-col :span="6">
        <h4>{{ i18n.$t("VersionControlUpdateTime") }}</h4>
        <a-range-picker v-model:value="searchTimeValue" />
      </a-col>
      <a-col :span="6" :offset="1">
        <a-button type="primary" size="middle" @click="searchLoginInfo()">{{
          i18n.$t("LoginInfoToolSearch")
        }}</a-button>
        <a-button
          size="middle"
          style="margin: 29px 0 0 20px"
          @click="resetInfo()"
          >{{ i18n.$t("LoginInfoToolClear") }}</a-button
        >
        <a-button
          size="middle"
          style="margin: 29px 0 0 20px"
          :disabled="group == 'ROLE_aftersale2'"
          @click="exportData()"
          >{{ i18n.$t("VersionControlExport") }}</a-button
        >
      </a-col>
      <a-col :span="24">
        <a-table
          style="margin-top: 10px"
          bordered
          @change="handleTableChange"
          :data-source="InfoData"
          :pagination="pagination"
          :loading="loading"
          :columns="columns"
          :row-key="(record) => record.id"
          :scroll="{ x: 1040 }"
        >
          <template #phoneType="{ text }">
            {{ phoneTypeOptions.find((item) => item.value == text).label }}
            <!-- {{ text == 1 ? "smart phone" : "feature phone" }} -->
          </template>
          <template #source="{ text }">
            {{ text == 1 ? "Manual" : "SPUG" }}
          </template>
          <template #operation="{ record }">
            <a-button
              :disabled="group === 'ROLE_aftersale2'"
              v-if="record.source != 2"
              type="primary"
              @click="ShowModalEdit(record)"
              >{{ i18n.$t("VersionControlTabelEdit") }}</a-button
            >
            <a-popconfirm
              v-if="InfoData.length"
              title="Sure to delete?"
              :disabled="group !== 'ROLE_admin'"
              @confirm="onDelete(record.id)"
            >
              <a-button
                :disabled="group !== 'ROLE_admin'"
                style="margin-top: 5px"
                type="primary"
                danger
                >{{ i18n.$t("VersionControlTabelDelete") }}</a-button
              >
            </a-popconfirm>
          </template>
          <template #control="{ text, record }">
            <a-switch
              v-model:checked="record.flashSwitch"
              :disabled="group === 'ROLE_aftersale2'"
              @change="(checked) => changeControl(checked, record)"
              :checked-children="i18n.$t('VersionControlTabelOpen')"
              :un-checked-children="i18n.$t('VersionControlTabelClose')"
            />
            <!-- </a-popconfirm> -->
          </template>
        </a-table>
        <label class="loginInfoTotalLabel">Total: {{ pagination.total }}</label>
      </a-col>
      <a-modal
        :title="
          VersionControlEditForm.id
            ? i18n.$t('NormalSettingEditTitle')
            : i18n.$t('VersionControlTabelAdd')
        "
        :width="800"
        :visible="ModalVisibleEdit"
        :confirm-loading="ConfirmLoadingEdit"
        :ok-text="i18n.$t('VersionControlInputModalConfirm')"
        :cancel-text="i18n.$t('VersionControlPopCancel')"
        @ok="handleOkEdit"
        @cancel="handleCancelEdit"
        :maskClosable="false"
        :destroyOnClose="true"
      >
        <a-form
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="rules"
          :model="VersionControlEditForm"
          ref="formRef"
        >
          <a-form-item
            name="brandName"
            :label="i18n.$t('VersionControlBrandName')"
          >
            <a-select
              show-search
              v-model:value="VersionControlEditForm.brandName"
              style="width: 100%"
              ref="select"
            >
              <a-select-option value="itel">itel</a-select-option>
              <a-select-option value="TECNO">TECNO</a-select-option>
              <a-select-option value="Infinix">Infinix</a-select-option>
              <a-select-option value="Spice">Spice</a-select-option>
              <a-select-option value="others">others</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            name="projectName"
            :label="i18n.$t('VersionControlProjectName')"
          >
            <a-input v-model:value="VersionControlEditForm.projectName" />
          </a-form-item>
          <a-form-item
            name="mainboard"
            :label="i18n.$t('VersionControlBomName')"
          >
            <a-input v-model:value="VersionControlEditForm.mainboard" />
          </a-form-item>
          <a-form-item
            name="bomConfig"
            :label="i18n.$t('VersionControlBomConfig')"
          >
            <a-input v-model:value="VersionControlEditForm.bomConfig" />
          </a-form-item>
          <a-form-item
            name="latestVersion"
            :label="i18n.$t('VersionControlLatestVersion')"
          >
            <a-select
              v-if="VersionControlEditForm.hasBuildPrefix"
              show-search
              allowClear
              v-model:value="VersionControlEditForm.latestVersion"
              ref="select"
              @change="changeLastestVersion"
            >
              <a-select-option
                v-for="item in searchLastestVersionOptions"
                :value="item.latestVersion"
                >{{ item.latestVersion }}</a-select-option
              >
            </a-select>
            <a-input
              v-else
              v-model:value="VersionControlEditForm.latestVersion"
            />
          </a-form-item>
          <a-form-item
            name="marketType"
            :label="i18n.$t('VersionControlMarket')"
          >
            <a-input v-model:value="VersionControlEditForm.marketType" />
          </a-form-item>
          <a-form-item name="latestNMark" :label="i18n.$t('VersionControlN')">
            <a-input v-model:value="VersionControlEditForm.latestNMark" />
          </a-form-item>
          <a-form-item
            name="phoneType"
            :label="i18n.$t('VersionControlMobileModel')"
          >
            <a-radio-group
              :options="phoneTypeOptions"
              v-model:value="VersionControlEditForm.phoneType"
            />
          </a-form-item>

          <!-- <div v-if="!VersionControlEditForm.id"> -->
          <div class="spiltLine"></div>
          <a-form-item
            name="buildPrefix"
            :label="i18n.$t('VersionControlBuildFix')"
          >
            <a-input
              v-model:value="VersionControlEditForm.buildPrefix"
              @change="changeBuildPrefix"
            />
          </a-form-item>
          <a-form-item
            name="lastVersionCompileTimestamp"
            :label="i18n.$t('VersionControlTimeStamp')"
          >
            <a-input
              v-model:value="VersionControlEditForm.lastVersionCompileTimestamp"
            />
          </a-form-item>
          <a-form-item
            name="flashSwitch"
            :label="i18n.$t('HeaderVersionControl')"
          >
            <a-switch
              v-model:checked="VersionControlEditForm.flashSwitch"
              :checked-children="i18n.$t('VersionControlTabelOpen')"
              :un-checked-children="i18n.$t('VersionControlTabelClose')"
            />
            <!-- <span class="btnTip">{{
                i18n.$t("VersionControlTabelCloseTipContent")
              }}</span> -->
          </a-form-item>
          <!-- </div> -->
          <!-- <a-form-item :label="i18n.$t('SystemNoticeContent')">
            <a-textarea
              v-model:value="VersionControlEditForm.content"
              :rows="4"
            />
          </a-form-item>
 -->
        </a-form>
      </a-modal>
    </a-row>
  </div>
</template>

<script>
import { useI18n } from "@/i18nPlugin";
import { createVNode, defineComponent, ref } from "vue";
import moment from "moment";
import { message, Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import {
  SearchVersionControlInfoData,
  AddProjectVersionData,
  UpdateProjectVersionData,
  DeleteProjectVersionData,
  getLatestVersionData,
  getPullDownData,
  updateFlashSwitchData,
  exportVersionData,
} from "../api/index";

export default defineComponent({
  setup() {
    const formRef = ref();
    const i18n = useI18n();
    const token = localStorage.getItem("userToken");
    const group = localStorage.getItem("Group");

    const timestampRequired = ref(false);
    const changeBuildPrefix = (e) => {
      timestampRequired.value = !!e.target.value;
    };
    const columns = ref([
      // {
      //   title: i18n.$t("VersionControlId"),
      //   width: 100,
      //   dataIndex: "id",
      // },
      {
        title: i18n.$t("VersionControlBrandName"),
        width: 120,
        dataIndex: "brandName",
      },
      {
        title: i18n.$t("VersionControlProjectName"),
        width: 120,
        dataIndex: "projectName",
      },
      {
        title: i18n.$t("VersionControlLatestVersion"),
        width: 250,
        dataIndex: "latestVersion",
      },
      {
        title: i18n.$t("VersionControlLatestN"),
        width: 120,
        dataIndex: "latestNMark",
      },
      {
        title: i18n.$t("VersionControlLowerestVersion"),
        width: 250,
        dataIndex: "minVersion",
      },
      {
        title: i18n.$t("VersionControlLowerestN"),
        width: 120,
        dataIndex: "minNMark",
      },
      {
        title: i18n.$t("VersionControlMarket"),
        width: 100,
        dataIndex: "marketType",
      },
      {
        title: i18n.$t("VersionControlBomName"),
        width: 100,
        dataIndex: "mainboard",
      },
      {
        title: i18n.$t("VersionControlBomConfig"),
        width: 100,
        dataIndex: "bomConfig",
      },
      {
        title: i18n.$t("VersionControlMobileModel"),
        width: 120,
        dataIndex: "phoneType",
        slots: { customRender: "phoneType" },
      },
      {
        title: i18n.$t("VersionControlBuildFix"),
        width: 200,
        dataIndex: "buildPrefix",
      },
      {
        title: i18n.$t("VersionControlTimeStamp"),
        width: 200,
        dataIndex: "lastVersionCompileTimestamp",
      },
      {
        title: i18n.$t("VersionControlSourceFrom"),
        width: 120,
        dataIndex: "source",
        slots: { customRender: "source" },
      },
      {
        title: i18n.$t("VersionControlUpdator"),
        width: 150,
        dataIndex: "reviser",
      },
      {
        title: i18n.$t("VersionControlUpdateTime"),
        width: 120,
        fixed: "right",
        dataIndex: "modifyTime",
      },
      {
        title: i18n.$t("VersionControlOperation"),
        dataIndex: "operation",
        width: 100,
        fixed: "right",
        slots: { customRender: "operation" },
      },
      {
        title: i18n.$t("HeaderVersionControl"),
        dataIndex: "flashSwitch",
        width: 100,
        fixed: "right",
        slots: { customRender: "control" },
      },
    ]);
    const rules = ref({
      brandName: [
        {
          required: true,
          message:
            i18n.$t("VersionControlSelectRequired") +
            i18n.$t("VersionControlBrandName"),
          trigger: "change",
        },
      ],
      phoneType: [
        {
          required: true,
          message:
            i18n.$t("VersionControlSelectRequired") +
            i18n.$t("VersionControlMobileModel"),
          // trigger: "change",
        },
      ],
      lastVersionCompileTimestamp: [
        {
          required: timestampRequired,
          message:
            i18n.$t("VersionControlInputRequired") +
            i18n.$t("VersionControlTimeStamp"),
          //trigger: "change",
        },
      ],
      latestNMark: [
        {
          required: true,
          message:
            i18n.$t("VersionControlInputRequired") + i18n.$t("VersionControlN"),
          trigger: "blur",
        },
      ],
      marketType: [
        {
          required: true,
          message:
            i18n.$t("VersionControlInputRequired") +
            i18n.$t("VersionControlMarket"),
          trigger: "blur",
        },
      ],
      latestVersion: [
        {
          required: true,
          message:
            i18n.$t("VersionControlInputRequired") +
            i18n.$t("VersionControlLatestVersion"),
          trigger: "blur",
        },
      ],
      mainboard: [
        {
          required: true,
          message:
            i18n.$t("VersionControlInputRequired") +
            i18n.$t("VersionControlBomName"),
          trigger: "blur",
        },
      ],
      projectName: [
        {
          required: true,
          message:
            i18n.$t("VersionControlInputRequired") +
            i18n.$t("VersionControlProjectName"),
          trigger: "blur",
        },
      ],
    });

    const searchLatestVersionValue = ref("");
    const searchMinVersionValue = ref("");
    const searchBuildPrefixValue = ref("");
    const searchProjectValue = ref("");
    const searchProjectOptions = ref([]);
    const searchMainBoardValue = ref("");
    const searchMainBoardOptions = ref([]);
    const searchTimeValue = ref(null);
    const searchLastestVersionOptions = ref([]);
    const changeLastestVersionData = ref({});
    const phoneTypeOptions = ref([
      {
        value: 1,
        label: "Smart Phone",
      },
      {
        value: 2,
        label: "Feature Phone",
      },
      {
        value: 3,
        label: "Others",
      },
    ]);

    let InfoData = ref([]);
    const pagination = ref({
      total: 0,
      current: 1,
      pageSize: 10,
    });
    const loading = ref(false);

    const getInfo = (currentPage, pageSize) => {
      loading.value = true;
      if (searchTimeValue._rawValue == null) {
        var SearchLoginInfoForm = {
          latestVersion: searchLatestVersionValue.value,
          minVersion: searchMinVersionValue.value,
          buildPrefix: searchBuildPrefixValue.value,
          projectName: searchProjectValue.value,
          mainboard: searchMainBoardValue.value,
          currentPage: currentPage,
          pageSize: pageSize,
        };
      } else {
        var SearchLoginInfoForm = {
          latestVersion: searchLatestVersionValue.value,
          minVersion: searchMinVersionValue.value,
          buildPrefix: searchBuildPrefixValue.value,
          projectName: searchProjectValue.value,
          mainboard: searchMainBoardValue.value,
          startDate: searchTimeValue.value[0]
            ? moment(searchTimeValue.value[0]).format("YYYY-MM-DD 00:00:00")
            : "",
          endDate: searchTimeValue.value[1]
            ? moment(searchTimeValue.value[1]).format("YYYY-MM-DD 23:59:59")
            : "",
          currentPage: currentPage,
          pageSize: pageSize,
        };
      }
      SearchVersionControlInfoData(SearchLoginInfoForm, token)
        .then((res) => {
          InfoData.value = res.data;
          pagination.value.total = res.total;
        })
        .catch((error) => console.log(error))
        .finally(() => (loading.value = false));
    };

    const exportData = () => {
      if (searchTimeValue._rawValue == null) {
        var SearchLoginInfoForm = {
          latestVersion: searchLatestVersionValue.value,
          minVersion: searchMinVersionValue.value,
          buildPrefix: searchBuildPrefixValue.value,
          projectName: searchProjectValue.value,
          mainboard: searchMainBoardValue.value,
        };
      } else {
        var SearchLoginInfoForm = {
          minVersion: searchMinVersionValue.value,
          buildPrefix: searchBuildPrefixValue.value,
          projectName: searchProjectValue.value,
          mainboard: searchMainBoardValue.value,
          startDate: searchTimeValue.value[0]
            ? moment(searchTimeValue.value[0]).format("YYYY-MM-DD 00:00:00")
            : "",
          endDate: searchTimeValue.value[1]
            ? moment(searchTimeValue.value[1]).format("YYYY-MM-DD 23:59:59")
            : "",
        };
      }
      exportVersionData(SearchLoginInfoForm, token)
        .then((res) => {
          const blob = new Blob([res], {
            type: "application/ynd.ms-excel;chartset=UTF-8",
          });
          const objectURL = URL.createObjectURL(blob);
          let btn = document.createElement("a");
          btn.download =
            "Software Version List - " + moment().format("YYYYMMDD") + " .xlsx";
          btn.href = objectURL;
          btn.click();
          URL.revokeObjectURL(objectURL);
          btn = null;
        })
        .catch((error) => console.log(error));
    };

    const handleTableChange = (pag) => {
      console.log(pag); //current   pageSize
      pagination.value.current = pag.current;
      pagination.value.pageSize = pag.pageSize;
      getInfo(pag.current, pag.pageSize);
    };

    const getPullDownList = () => {
      //传入1则查询项目名称，传入2则查询主板名称
      getPullDownData({ param: 1 }, token)
        .then((res) => {
          searchProjectOptions.value = res.data;
        })
        .catch((error) => console.log(error));
      getPullDownData({ param: 2 }, token)
        .then((res) => {
          searchMainBoardOptions.value = res.data;
        })
        .catch((error) => console.log(error));
    };

    const searchLoginInfo = () => {
      pagination.value.current = 1;
      getInfo(pagination.value.current, pagination.value.pageSize);
    };

    const resetInfo = () => {
      searchLatestVersionValue.value = "";
      searchMinVersionValue.value = "";
      searchBuildPrefixValue.value = "";
      searchProjectValue.value = "";
      searchMainBoardValue.value = "";
      searchTimeValue.value = null;
      pagination.value.current = 1;

      getInfo(pagination.value.current, pagination.value.pageSize);
    };

    const changeControl = (checked, record) => {
      record.flashSwitch = !record.flashSwitch;
      let tipsTitle = record.flashSwitch
        ? i18n.$t("VersionControlTabelOpenTipTitle")
        : i18n.$t("VersionControlTabelCloseTipTitle");
      let tipsContent = record.flashSwitch
        ? i18n.$t("VersionControlTabelOpenTipContent")
        : i18n.$t("VersionControlTabelCloseTipContent");
      Modal.confirm({
        title: () => tipsTitle,
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: i18n.$t("VersionControlPopContinue"),
        cancelText: i18n.$t("VersionControlPopCancel"),
        content: () =>
          createVNode("div", {}, [
            createVNode("div", { style: "color:red;" }, tipsContent),
            createVNode(
              "div",
              { style: "color:gray;" },
              i18n.$t("VersionControlTabelControlTip")
            ),
          ]),
        // createVNode("div", { style: "color:red;" }, "Some descriptions"),
        onOk() {
          console.log("OK", record, checked);
          let queryObj = {
            id: record.id,
            flashSwitchValue: checked,
          };
          updateFlashSwitchData(queryObj, token)
            .then((res) => {
              if (res.status == 200) {
                // this.$message.success('添加成功');
                ConfirmLoadingEdit.value = false;
                ModalVisibleEdit.value = false;
                getInfo(pagination.value.current, pagination.value.pageSize);
                // console.log(res)
              } else {
                ConfirmLoadingEdit.value = false;
              }
            })
            .catch((error) => {
              // this.$message.danger('添加失败');
              ConfirmLoadingEdit.value = false;
              console.log(error);
            });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    };

    const ModalVisibleEdit = ref(false);
    const ConfirmLoadingEdit = ref(false);

    //编辑
    const VersionControlEditForm = ref({
      bomConfig: "",
      brandName: "",
      buildPrefix: "",
      fingerprint: "",
      flashSwitch: true,
      id: "",
      lastVersionCompileTimestamp: null,
      latestNMark: "",
      latestVersion: "",
      mainboard: "",
      marketType: "",
      phoneType: null,
      projectName: "",
      hasBuildPrefix: false,
    });

    const onDelete = (id) => {
      DeleteProjectVersionData(
        {
          id: id,
        },
        token
      )
        .then((res) => {
          if (res.status == 200) {
            // const TempAccountData = [...AccountData.value];
            // AccountData.value = TempAccountData.filter(
            //   (item) => item.id !== id
            // );
            getInfo(pagination.value.current, pagination.value.pageSize);
          }
        })
        .catch((error) => {
          // this.$message.danger('添加失败');
          console.log(error);
        });
    };

    const ShowModalEdit = (record) => {
      VersionControlEditForm.value = JSON.parse(JSON.stringify(record));
      if (record.id) {
        record.buildPrefix && getLastVersion(record.id);
        VersionControlEditForm.value.id = record.id;
        VersionControlEditForm.value.hasBuildPrefix = !!record.buildPrefix;
      } else {
        //formRef.value.resetFields();
        VersionControlEditForm.value.hasBuildPrefix = false;
        VersionControlEditForm.value.id = null;
        VersionControlEditForm.value.flashSwitch = true;
      }
      ModalVisibleEdit.value = true;
    };
    const getLastVersion = (id) => {
      getLatestVersionData({ id: id }, token)
        .then((res) => {
          searchLastestVersionOptions.value = res.data;
        })
        .catch((error) => console.log(error));
    };
    const changeLastestVersion = (v) => {
      let temp = searchLastestVersionOptions.value.find(
        (item) => item.latestVersion == v
      );

      // if (temp.latestNMark) {
      //   changeLastestVersionData.value = temp;
      // } else {
      changeLastestVersionData.value.buildPrefix = temp.buildPrefix;
      changeLastestVersionData.value.fingerprint = temp.fingerprint;
      changeLastestVersionData.value.lastVersionCompileTimestamp =
        temp.lastVersionCompileTimestamp;
      changeLastestVersionData.value.latestVersion = temp.latestVersion;
      // }
      //changeLastestVersionData.value = temp;
    };
    const handleOkEdit = () => {
      formRef.value
        .validate()
        .then(() => {
          let formData = VersionControlEditForm._rawValue;
          formData.id
            ? updateProjectVersion(formData)
            : addProjectVersion(formData);
        })
        .catch((err) => {
          console.log("error", err);
        });
    };

    const addProjectVersion = (formData) => {
      AddProjectVersionData(formData, token)
        .then((res) => {
          if (res.status == 200) {
            //this.$message.success("添加成功");
            ConfirmLoadingEdit.value = false;
            ModalVisibleEdit.value = false;
            getInfo(pagination.value.current, pagination.value.pageSize);
            // console.log(res)
          } else {
            ConfirmLoadingEdit.value = false;
          }
        })
        .catch((error) => {
          // this.$message.danger('添加失败');
          ConfirmLoadingEdit.value = false;
          console.log(error);
        });
    };
    const updateProjectVersion = (formData) => {
      let data = Object.assign(formData, changeLastestVersionData.value);
      UpdateProjectVersionData(data, token)
        .then((res) => {
          if (res.status == 200) {
            ConfirmLoadingEdit.value = false;
            ModalVisibleEdit.value = false;
            getInfo(pagination.value.current, pagination.value.pageSize);
            message.success("修改成功");
          } else {
            ConfirmLoadingEdit.value = false;
          }
        })
        .catch((error) => {
          // this.$message.danger('添加失败');
          ConfirmLoadingEdit.value = false;
          console.log(error);
        });
    };

    const handleCancelEdit = () => {
      ModalVisibleEdit.value = false;
      formRef.value.resetFields();
    };

    return {
      i18n,
      token,
      group,
      changeBuildPrefix,
      searchLatestVersionValue,
      searchMinVersionValue,
      searchBuildPrefixValue,
      searchProjectValue,
      searchProjectOptions,
      searchMainBoardValue,
      searchMainBoardOptions,
      searchTimeValue,
      searchLoginInfo,
      searchLastestVersionOptions,
      changeLastestVersionData,
      formRef,
      resetInfo,
      getInfo,
      pagination,
      loading,
      columns,
      defaultChecked: true,
      labelCol: {
        style: {
          width: "150px",
        },
      },
      wrapperCol: {
        span: 16,
      },
      phoneTypeOptions,
      rules,
      handleTableChange,
      InfoData,
      getPullDownList,
      ModalVisibleEdit,
      VersionControlEditForm,
      changeLastestVersion,
      ShowModalEdit,
      changeControl,
      handleOkEdit,
      handleCancelEdit,
      onDelete,
      exportData,
    };
  },
  mounted() {
    this.getInfo(1, 10);
    this.getPullDownList();
  },
});
</script>

<style scoped>
.topDiv {
  margin: 10px 0;
}
.spiltLine {
  border-top: 1px solid #dfdfdf;
  margin: 20px -21px 40px -21px;
}
.btnTip {
  margin-left: 40px;
  color: gray;
}
.exportLoginData {
  margin-top: 20px;
  text-align: right;
}
.showTaskDrawerLabel {
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}
.loginInfoTotalLabel {
  position: absolute;
  margin-top: -45px;
  font-weight: bold;
}
</style>